import {createPreloadableLazyComponent} from '../../util/lazyImport';
import {type RouteData} from '../types';
import {
  GALLERY_PATH,
  GALLERY_PATH_SEGMENT,
  OLD_GALLERY_DISCUSSION_EDIT_PATH,
  OLD_GALLERY_DISCUSSION_VIEW_PATH,
  OLD_REPORT_PAGE_EDIT_PATH,
  OLD_REPORT_PAGE_VIEW_PATH,
  REPORT_PAGE_EDIT_PATH,
  REPORT_PAGE_VIEW_PATH,
  REPORT_PAGE_VIEW_PUBLISHED_WORK_PATH,
} from './reportPaths';

export const FULLY_CONNECTED_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'FullyConnected',
    },
    isPrivateRoute: false,
    path: GALLERY_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/FC')
    ).Component,
  },
  {
    path: '/fullyconnected',
    redirect: `/${GALLERY_PATH_SEGMENT}`,
  },
  {
    path: '/fc',
    redirect: `/${GALLERY_PATH_SEGMENT}`,
  },
  {
    path: '/gallery',
    redirect: `/${GALLERY_PATH_SEGMENT}`,
  },
];

export const REPORT_ROUTES_DATA: RouteData[] = [
  {
    // This old edit report page route will be redirected to /reportlist
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'OldReportPageEdit',
    },
    exact: true,
    isPrivateRoute: false,
    path: OLD_REPORT_PAGE_EDIT_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/ReportPage/ReportPageRouter')
    ).Component,
  },
  {
    // This old view report page route will be redirected to /reportlist
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'OldReportPageView',
    },
    exact: true,
    isPrivateRoute: false,
    path: OLD_REPORT_PAGE_VIEW_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/ReportPage/ReportPageRouter')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: true,
      datadogViewName: 'ReportEdit',
    },
    exact: true,
    isPrivateRoute: false,
    path: REPORT_PAGE_EDIT_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/ReportPage/ReportPageRouter')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: true,
      datadogViewName: 'ReportView',
    },
    exact: true,
    isPrivateRoute: false,
    path: REPORT_PAGE_VIEW_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/ReportPage/ReportPageRouter')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: true,
      datadogViewName: 'ReportViewPublished',
    },
    exact: true,
    isPrivateRoute: false,
    path: REPORT_PAGE_VIEW_PUBLISHED_WORK_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/ReportPage/ReportPageRouter')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'FullyConnectedDiscussionEdit',
    },
    exact: true,
    isPrivateRoute: false,
    path: OLD_GALLERY_DISCUSSION_EDIT_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/ReportPage/ReportPageRouter')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'FullyConnectedDiscussionView',
    },
    exact: true,
    isPrivateRoute: false,
    path: OLD_GALLERY_DISCUSSION_VIEW_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/ReportPage/ReportPageRouter')
    ).Component,
  },
];
